module.exports = "#mechanicmap{\r\n    width: 950px;\r\n    height: 200px;\r\n}"